import React from "react";
import { Button } from "@/components/ui/button";

export const QuestionRenderer = ({ question, answer, onAnswer, category }) => {
  if (question.type === "choice") {
    return (
      <div className="grid grid-cols-1 gap-3">
        {question.options.map((option) => (
          <Button
            key={option}
            variant={answer === option ? "default" : "outline"}
            onClick={() => onAnswer(question.id, option, category)}
            className={`rounded-xl h-auto py-4 px-6 text-left justify-start ${
              answer === option ? 'bg-primary text-[#384451] border-primary' : 'hover:bg-primary/10'
            }`}
            data-testid={`option-${question.id}-${option}`}
          >
            {option}
          </Button>
        ))}
      </div>
    );
  }

  if (question.type === "scale") {
    return (
      <div className="space-y-4">
        <input
          type="range"
          min={question.min}
          max={question.max}
          value={answer || Math.floor((question.max + question.min) / 2)}
          onChange={(e) => onAnswer(question.id, parseInt(e.target.value), category)}
          className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-primary"
          data-testid={`scale-${question.id}`}
        />
        <div className="flex justify-between text-sm">
          <span className="text-[#384451]/60">{question.labels?.[0] || question.min}</span>
          <span className="font-semibold text-primary text-lg">
            {answer || Math.floor((question.max + question.min) / 2)}
          </span>
          <span className="text-[#384451]/60">{question.labels?.[1] || question.max}</span>
        </div>
      </div>
    );
  }

  if (question.type === "boolean") {
    return (
      <div className="flex gap-4">
        <Button
          variant={answer === true ? "default" : "outline"}
          onClick={() => onAnswer(question.id, true, category)}
          className={`flex-1 rounded-xl h-14 text-lg ${
            answer === true ? 'bg-primary text-[#384451]' : 'hover:bg-primary/10'
          }`}
          data-testid={`bool-yes-${question.id}`}
        >
          Sí ✓
        </Button>
        <Button
          variant={answer === false ? "default" : "outline"}
          onClick={() => onAnswer(question.id, false, category)}
          className={`flex-1 rounded-xl h-14 text-lg ${
            answer === false ? 'bg-gray-500 text-white' : 'hover:bg-gray-100'
          }`}
          data-testid={`bool-no-${question.id}`}
        >
          No
        </Button>
      </div>
    );
  }

  return null;
};
